import React from "react";
import "./Card.css";
import { useNavigate } from "react-router-dom";

const Card = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="big-container">
      <h1 className="event-title">Be a part of the big event</h1>
      <div className="event-container">
        {/* Left Side: Event Information */}
        <div className="event-info">
          <p>
            SERBIAN TROPHY is an offroad competition organized by the SERBIA 4 ×
            4 Off-road team. The competition is divided into three categories
            (classes): TROPHY, ADVENTURE (competition classes) and TURIST
            (revision class). All necessary information, radar book, referees,
            rulebook and everything else necessary for this event is provided by
            the organizer. The organizer reserves the right to change the hourly
            schedule provided in the invitation letter, as well as to change the
            rulebook in case of unexpected events, but undertakes to inform the
            participants on time (before the start of the first stage).
          </p>
        </div>

        {/* Right Side: Registration Card */}
        <div className="registration-box">
          <h2 className="registration-price">€300</h2>
          <p className="registration-text">REGISTRATION</p>
          <p className="registration-fee">FEE</p>
          <hr className="separator" />
          <p className="registration-subtext">Per person</p>
          {/* <button
            className="register-button"
            onClick={() => navigate("/registration")}
          >
            REGISTER
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Card;
